import {
  allAssociadoProfileIds,
  allPertencerProfileIds,
  allProfileIds,
} from 'library/AuthProfile';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import PerfilAssociado from 'store/modules/auth/PerfilAssociado';
import PerfilDeslogado from 'store/modules/auth/PerfilDeslogado';
import PerfilPertencerAdmin from 'store/modules/auth/PerfilPertencerAdmin';
import PerfilPertencerChat from 'store/modules/auth/PerfilPertencerChat';
import PerfilPertencerConsulta from 'store/modules/auth/PerfilPertencerConsulta';
import PerfilPertencerGestao from 'store/modules/auth/PerfilPertencerGestao';

export const isPertencerProfile = (profile: IAuthUserPerfil): boolean => {
  return allPertencerProfileIds.indexOf(profile.id) > -1;
};

export const isAssociadoProfile = (profile: IAuthUserPerfil): boolean => {
  return allAssociadoProfileIds.indexOf(profile.id) > -1;
};

export const getProfileById = (
  id: AuthUserPerfilId
): IAuthUserPerfil | null => {
  switch (id) {
    case AuthUserPerfilId.PertencerChat:
      return PerfilPertencerChat;
    case AuthUserPerfilId.PertencerAdmin:
      return PerfilPertencerAdmin;
    case AuthUserPerfilId.PertencerGestao:
      return PerfilPertencerGestao;
    case AuthUserPerfilId.PertencerConsulta:
      return PerfilPertencerConsulta;
    // case AuthUserPerfilId.AssociadoConvidado:
    //   return PerfilAssociadoConvidado;
    case AuthUserPerfilId.Deslogado:
      return PerfilDeslogado;
    // case AuthUserPerfilId.Associado:
    default:
      return PerfilAssociado;
  }
};

export const getProfileByIds = (
  ids: AuthUserPerfilId[]
): IAuthUserPerfil | null => {
  const foundProfiles: AuthUserPerfilId[] = allProfileIds.filter(
    (id: AuthUserPerfilId): boolean => {
      if (ids.indexOf(id) > -1) {
        return true;
      }
      return false;
    }
  );
  if (foundProfiles.length === 1) {
    return getProfileById(foundProfiles[0]);
  }
  if (foundProfiles.includes(AuthUserPerfilId.PertencerAdmin)) {
    return getProfileById(AuthUserPerfilId.PertencerAdmin);
  }
  if (foundProfiles.includes(AuthUserPerfilId.PertencerGestao)) {
    return getProfileById(AuthUserPerfilId.PertencerGestao);
  }
  if (foundProfiles.includes(AuthUserPerfilId.PertencerConsulta)) {
    return getProfileById(AuthUserPerfilId.PertencerConsulta);
  }
  if (foundProfiles.includes(AuthUserPerfilId.PertencerChat)) {
    return getProfileById(AuthUserPerfilId.PertencerChat);
  }
  return null;
};

export const getProfileByJWTRoles = (
  roles: string[]
): IAuthUserPerfil | null => {
  if (roles.length > 0) {
    return getProfileByIds(
      roles
        .map((role: string): string => {
          if (role.indexOf('/') > -1) {
            return role.split('/')[1];
          }
          return role;
        })
        .filter((role: string): boolean => {
          if ((allProfileIds as string[]).indexOf(role) > -1) {
            return true;
          }
          return false;
        }) as AuthUserPerfilId[]
    );
  }
  return null;
};
